import FilterStoreAdapter from '../preset-views/filter-store-adapter';

export const planningLsName = 'DispatchView';

class DispatchStore {
	filters = new FilterStoreAdapter(planningLsName);
}

export default DispatchStore;
